export default "__VITE_ASSET__k1Vw4jM2__"